import { createScriptLoader } from '@bigcommerce/script-loader';

const loader = createScriptLoader();

const drawRegionsMap = (google) => {
    const data = google.visualization.arrayToDataTable([
        ['Country'],
        ['Poland'],
        ['United Kingdom'],
        ['Czech Republic'],
        ['Slovakia'],
        ['Romania'],
        ['Hungary'],
        ['Bulgaria'],
        ['Germany'],
        ['Croatia'],
        ['Greece'],
        ['Ukraine'],
    ]);

    const options = {
        region: '150',
        defaultColor: '#bebebe',
    };

    const chart = new google.visualization.GeoChart(document.querySelector('#europe-map'));

    chart.draw(data, options);

    // chart.draw(showroomsData, options);
};

loader.loadScript('https://www.gstatic.com/charts/loader.js').then(() => {
    window.google.charts.load('current', {
        packages: ['geochart'],
        // Note: Because markers require geocoding, you'll need a mapsApiKey.
        // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
        // mapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
    });

    window.google.charts.setOnLoadCallback(() => {
        drawRegionsMap(window.google);
    });
});
